'use client';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import arLang from './ar.json';
import enLang from './en.json';

export const resources = {
  en: { translation: enLang },
  ar: { translation: arLang },
} as const;

export type AvailableLangs = keyof typeof resources;

export function ensureI18n(lang: AvailableLangs) {
  if (!i18next.isInitialized) {
    i18next
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        lng: lang,
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
        detection: { order: ['cookie', 'navigator'], caches: [] },
      });
  } else if (i18next.language !== lang) {
    i18next.changeLanguage(lang);
  }
  return i18next;
}

